import { ScreenReaderOnly } from './ScreenReaderOnly';
export var ScreenReaderAlertPoliteness;
(function (ScreenReaderAlertPoliteness) {
    ScreenReaderAlertPoliteness["ASSERTIVE"] = "assertive";
    ScreenReaderAlertPoliteness["POLITE"] = "polite";
    ScreenReaderAlertPoliteness["OFF"] = "off";
})(ScreenReaderAlertPoliteness || (ScreenReaderAlertPoliteness = {}));
/**
 *
 */
export const ScreenReaderAlert = ({ children, politeness = ScreenReaderAlertPoliteness.ASSERTIVE, visible = false, }) => {
    return visible ? (<span role="alert" aria-live={politeness}>
      {children}
    </span>) : (<ScreenReaderOnly role="alert" aria-live={politeness}>
      {children}
    </ScreenReaderOnly>);
};
